import { render } from "./UploadHeader.component.vue?vue&type=template&id=4364f93e&scoped=true&ts=true"
import script from "./UploadHeader.component.vue?vue&type=script&lang=ts"
export * from "./UploadHeader.component.vue?vue&type=script&lang=ts"

import "./UploadHeader.component.vue?vue&type=style&index=0&id=4364f93e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4364f93e"]])

export default __exports__